"use strict";

const bundleTimestamp = BUNDLE_TIMESTAMP;
const bundleAppEnv = BUNDLE_APP_ENV;
const bundleAppVersion = BUNDLE_APP_VERSION;
const bundleBugsnagKey = BUNDLE_BUGSNAG_KEY;
const bundleGoogleAnalyticsMeasurementId = BUNDLE_GOOGLE_ANALYTICS_MEASUREMENT_ID;

let dummyBugsnag = {
  notify: (error) => console.warn(error),
  leaveBreadcrumb: () => {},
  setUser: () => {},
  setContext: () => {},
  setMetadata: () => {},
  clearMetadata: () => {},
  addOnError: () => {},
  removeOnError: () => {},
  addOnSession: () => {},
  removeOnSession: () => {},
  getPlugin: () => ({}),
  isStarted: () => false
};
window.bugsnagClient = dummyBugsnag;

try {
  if ((bundleBugsnagKey?.trim() ?? '').length <= 0) {
    throw new Error('[Bugsnag] API key is not set.');
  }

  if (typeof Bugsnag === 'undefined') {
    throw new Error('[Bugsnag] Object is undefined.');
  }

  window.bugsnagClient = Bugsnag.start({
    apiKey: bundleBugsnagKey,
    appVersion: bundleAppVersion
    // autoTrackSessions: false // prevent CORS errors
  });
} catch (error) {
  window.bugsnagClient.notify(error);
}

// Initialize SHARED
window.SHARED = {
  environment: bundleAppEnv,
  version: bundleAppVersion,
  gaClientId: null,
  gaSessionId: null,
  googleAnalyticsMeasurementId: bundleGoogleAnalyticsMeasurementId
};

// Initialize dataLayer and gTag
window.dataLayer = window.dataLayer || [];
function gtag(){window.dataLayer.push(arguments);}
window.gtag = gtag;

// Send gTag CONSENT
window.gtag('consent', 'default', {
  'ad_storage': 'granted',
  'ad_user_data': 'granted',
  'ad_personalization': 'granted',
  'analytics_storage': 'granted'
});

// Send ENV and VERSION
window.dataLayer.push({
  'environment': window.SHARED.environment,
  'version': window.SHARED.version
});

function getGaCookieValue(idType) {
  const patterns = {
    client_id: /_ga=GA\d\.\d\.(.+?);/,
    session_id: /_ga_[A-Z0-9]+=GS\d\.\d\.s(\d+)\$/
  };

  try {
    if (idType !== 'client_id' && idType !== 'session_id') {
      throw new Error('idType must be \'client_id\' or \'session_id\'');
    }

    const match = document.cookie.match(patterns[idType]);
    const id = match?.[1]?.trim();

    if ((id?.trim() ?? '').length <= 0) {
      throw new Error('No value for \'id\'');
    }

    return id;
  } catch (error) {
    window.bugsnagClient.notify(new Error(`[Google Analytics] Failed to get GA idType '${idType}': ${error.message}`));
    return null;
  }
}
window.getGaCookieValue = getGaCookieValue;

async function gTagGetFieldValue(fieldId) {
  const TIMEOUT_MS = 3000;
  const targetId = window.SHARED.googleAnalyticsMeasurementId;

  try {
    if (!targetId?.trim()) {
      throw new Error('Missing Google Analytics Measurement Id');
    }

    if (fieldId !== 'client_id' && fieldId !== 'session_id') {
      throw new Error('fieldId must be \'client_id\' or \'session_id\'');
    }

    const id = await Promise.race([
      new Promise((resolve) => {
        window.gtag('get', targetId, fieldId, resolve);
      }),
      new Promise((_, reject) => 
        setTimeout(() => reject(new Error(`Timeout after ${TIMEOUT_MS}ms`)), TIMEOUT_MS)
      )
    ]);

    if ((id?.trim() ?? '').length <= 0) {
      throw new Error('No value for \'id\'');
    }

    return id;
  } catch (error) {
    window.bugsnagClient.notify(new Error(`[Google Analytics] Failed to get GA fieldId '${fieldId}': ${error.message}`));
    return null;
  }
}
window.gTagGetFieldValue = gTagGetFieldValue;

// 1st: Set GA COOKIE values in gtm.init: session_id, then client_id
// This gets values quick, but if first visit, may not get client_id
// For Analyst use primarily, and default values if gtag() fails
(function initCookieGaSessionId() {
  const cookieGaSessionId = window.getGaCookieValue('session_id');

  if (cookieGaSessionId) {
    window.SHARED.gaSessionId = cookieGaSessionId;
    window.dataLayer.push({event: 'gtm.init', ga_session_id: cookieGaSessionId});
  }
})();

(function initCookieGaClientId() {
  const cookieGaClientId = window.getGaCookieValue('client_id');

  if (cookieGaClientId) {
    window.SHARED.gaClientId = cookieGaClientId;
    window.dataLayer.push({event: 'gtm.init', ga_client_id: cookieGaClientId});
  }
})();

// 2nd: Set gTag values in dataLayer: client_id, then session_id
// Use for in App purposes when populating payloads
// Updates values with latest if COOKIE doesn't get both
(async function initGtagGaClientId() {
  const gTagGaClientId = await window.gTagGetFieldValue('client_id');

  if (gTagGaClientId) {
    window.SHARED.gaClientId = gTagGaClientId;
    window.dataLayer.push({'ga_client_id': gTagGaClientId});
  }
})();

(async function initGtagGaSessionId() {
  const gTagGaSessionId = await window.gTagGetFieldValue('session_id');

  if (gTagGaSessionId) {
    window.SHARED.gaSessionId = gTagGaSessionId;
    window.dataLayer.push({'ga_session_id': gTagGaSessionId});
  }
})();
